import { useMutation, useQuery } from '@apollo/client';
import { EmailEditor } from '@nile/banyan/src/Components/Editors';
import { AttachmentItemHolder } from '@nile/banyan/src/Components/Editors/RTEditor';
import {
  ALL_MODULES,
  AppContext,
  getDownloadURL,
  getHeaderValue,
  getObjectValueCount,
  getTranslatedText,
  Loader,
  T1,
  toast,
  DateTimeFormatter,
  useUserMSPCheckHook,
  useIsAuthorisedHook,
  TabContent,
  TabsContainer,
  SideConversations,
  NewSideConversation,
  isAuthorised,
  sideConversationPricingPlans,
  EmptyTabState,
  useCheckFeatureGating,
  fetchApi,
  getConversationOrder,
  scrollToBottom,
  scrollToTop,
  COLOR_MAP
} from '@nile/components';
import MultipleNamesHandler from '@nile/components/src/Pebbles/multipleNamesHandler';
import {
  AccountClient,
  CREATE_CLIENT_CONVERSATION,
  GET_CLIENT_USERS,
  UPDATE_READ_STATUS,
  GET_USER_PROFILE,
  useCachedQuery,
  GET_CLIENT_CONVERSATION_REPLY_RECIPEINTS,
  GET_VENDOR_CONVERSATION_LIST,
  GET_NOTE_LIST
} from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import Recepients from '@nile/mangifera/src/Components/Chat/Recepients';
import { Receiver, Sender } from '@nile/mangifera/src/Pebbles/chat';
import { SelectUsers } from '@nile/mangifera/src/Pebbles/ChatContainer';
import {
  Button,
  Avatar,
  Link,
  TextStyle,
  Card,
  ButtonGroup,
  DisplayText
} from '@superops/ui-design-system';
import dayjs from 'dayjs';
import dompurify from 'dompurify';
import Collapse from 'react-collapse';
import { EditorState } from 'draft-js';
import { cloneDeep, pick } from 'lodash';
import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  useRef
} from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Tooltip } from 'react-clone-tippy';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { NotesContainer } from '@nile/mangifera/src/Containers/ChatContainers';
import { dompurifier } from '@nile/components/src/Utils/helpers';
import {
  ThreadWrapper,
  Container,
  Wrapper,
  ReplyThreadWrapper,
  EditorHolder,
  ItemHolders,
  AttachmentsContainer,
  CopyMailUsers,
  getUserName,
  findLastIndex,
  getCCUsersToCarryForward,
  getCCUsers,
  getBccUsers,
  ConversationThreadHeader,
  ConversationBubble,
  ReplyWidget,
  ComposeSection,
  HiddenActions
} from '@nile/client_management/src/Components/Conversations/CommonConversations';

function QuoteConversations(props) {
  const { conversations, intl, quoteId } = props;
  const flags = useFlags();
  const appContext = useContext(AppContext);
  const isMSP = useUserMSPCheckHook();
  const currentUser = appContext?.user || {};
  const planId = currentUser?.chargeBeePlanId?.toLowerCase();
  const userRole = appContext?.user?.role?.roleFeatureList || [];
  const isEditAuthorised = useIsAuthorisedHook('quote.edit');
  const showSideConversation = useCheckFeatureGating('SIDE_CONVERSATIONS')
    ?.enabled;

  // value from user preferred conversation order
  const conversationOrder = getConversationOrder() || 'ASC';

  const {
    data: sideConversationData,
    loading: sideConversationLoading,
    error: sideConversationError,
    refetch: sideConversationRefetch
  } = useQuery(GET_VENDOR_CONVERSATION_LIST, {
    client: AccountClient,
    variables: {
      input: {
        module: 'QUOTE',
        listInfo: {
          condition: {
            joinOperator: 'AND',
            operands: [
              {
                joinOperator: 'AND',
                operands: [
                  {
                    attribute: 'parentConversationId',
                    operator: 'isEmpty'
                  }
                ]
              },
              {
                joinOperator: 'AND',
                operands: [
                  {
                    attribute: 'workItem.workId',
                    operator: 'is',
                    value: quoteId
                  }
                ]
              }
            ]
          },
          sort: [
            {
              attribute: 'time',
              order: conversationOrder
            }
          ]
        }
      }
    }
  });
  const { data: notesList, loading: notesListLoading } = useQuery(
    GET_NOTE_LIST,
    {
      skip: !isMSP,
      fetchPolicy: 'cache-and-network',
      variables: {
        input: {
          workItem: {
            workId: quoteId,
            module: 'QUOTE'
          }
        }
      }
    }
  );
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [sideConversationToBeOpened, setSideConversationToBeOpened] = useState(
    null
  );
  const emailSignature = currentUser?.emailSignature;

  useEffect(() => {
    let vendorSideConversation =
      sideConversationData?.getVendorConversationsList?.conversations || [];
    if (vendorSideConversation?.length > 0) {
      if (conversationOrder === 'ASC') {
        //set conversationId in state to open latest conversation
        let openedConversationId =
          vendorSideConversation[vendorSideConversation.length - 1]
            ?.conversationId;
        openedConversationId &&
          setSideConversationToBeOpened(openedConversationId);
      }
    }
  }, [sideConversationData]);

  const switchTabIndex = (idx) => {
    setActiveTabIndex(idx);
  };

  const createNewSideConversation = () => {
    function onSubmit(data) {
      // refetchSideConversation();
      // switchToConnect(data);
      sideConversationRefetch();
    }
    return (
      <NewSideConversation
        plain
        intl={intl}
        workItemId={quoteId}
        module="QUOTE"
        updateCache={() => {}}
        onSubmit={onSubmit}
        backgroundThreadConversation={flags?.sideConversationBackgroundThread}
      />
    );
  };

  const tabs = [
    {
      id: 'conversations',
      content: (
        <TabContent
          content={`${getTranslatedText(intl, 'quote.details.conversations')}`}
          // icon={<SVGIcon name="helpcenter" />}
          count={conversations.length || 0}
        />
      ),
      iconName: 'Conversation',
      panelID: 'accepts-tasks-content',
      authorisation: 'clientConversation.view',
      // component: <TaskContainer ticket={ticket} />
      component: conversations.length ? (
        <ChatThreads
          conversations={conversations}
          emailSignature={emailSignature}
          isOpened
          {...props}
        />
      ) : (
        <Container border={props.outsideSheet} className="full-height">
          <EmptyTabState
            iconName="EmptyTabConversation"
            title="quote.conversations.emptyState.title"
            description="quote.conversations.emptyState.description"
          />
        </Container>
      )
    },
    {
      id: 'notes',
      content: (
        <TabContent
          content={`${getTranslatedText(intl, 'quote.details.notes')}`}
          // icon={<SVGIcon name="helpcenter" />}
          count={notesList?.getNoteList?.length || 0}
        />
      ),
      iconName: 'Notes',
      panelID: 'quote-notes',
      allowOnlyMSP: true,
      // authorisation: 'quote.edit',
      component: (
        <Container border={props.outsideSheet} className="full-height">
          <NotesContainer
            module="QUOTE"
            workItemId={quoteId}
            placeholder="quote.details.notes.placeHolder.desc"
            disableEdit={!useIsAuthorisedHook('quote.edit')}
            emptyStateTitle="quote.notes.emptyState.title"
            emptyStateDescription="quote.notes.emptyState.description"
          />
        </Container>
      )
    },
    {
      id: 'connect',
      content: (
        <TabContent
          content={`${getTranslatedText(
            intl,
            'app.common.sideConversation.title'
          )}`}
          // icon={<SVGIcon name="helpcenter" />}
          count={
            sideConversationData?.getVendorConversationsList?.conversations
              .length || 0
          }
        />
      ),
      iconName: 'Helpcenter',
      panelID: 'connect',
      allowOnlyMSP: true,
      featureGateName: 'SIDE_CONVERSATIONS',
      // authorisation: 'quote.edit',
      pricingPlans: sideConversationPricingPlans,
      // component: <TaskContainer ticket={ticket} />
      component: (
        <Container border={props.outsideSheet} className="full-height">
          <SideConversations
            module="QUOTE"
            workItemId={quoteId}
            refetch={sideConversationRefetch}
            updateFeedsCache={() => {}}
            createNewSideConversation={
              showSideConversation &&
              isEditAuthorised &&
              createNewSideConversation
            }
            vendorConversations={
              sideConversationData?.getVendorConversationsList?.conversations
            }
            conversationToBeOpened={sideConversationToBeOpened}
            emptyStateData={{
              description:
                'quote.details.sideConversation.emptyState.description'
            }}
            backgroundThreadConversation={
              flags?.sideConversationBackgroundThread
            }
          />
        </Container>
      )
    }
  ].filter(({ pricingPlans, featureGateName }) => {
    if (featureGateName) {
      return useCheckFeatureGating(featureGateName)?.enabled;
    }
    return true;
  });

  const allowedTabs = tabs.filter((el) => {
    if (!el.allowOnlyMSP) return true;
    return useUserMSPCheckHook();
  });

  let authorisedTabs = allowedTabs.filter((el) => {
    if (!el.authorisation) return true;
    const isFeatureAuthorised = isAuthorised(userRole, `${el.authorisation}`);
    return isFeatureAuthorised;
  });

  if (currentUser.accountType !== 'MSP') {
    authorisedTabs = authorisedTabs.filter((el) => el.id !== 'connect');
  }

  if (authorisedTabs?.length)
    return (
      <div className="fh common-conversation-tabs">
        <TabsContainer
          onTabChange={switchTabIndex}
          activeTabIndex={activeTabIndex}
          tabs={authorisedTabs}
          wrapperClassNames="ghost-white"
        />
      </div>
    );
  return null;
}

function QuoteConversationsContainer(props) {
  const { conversations } = props;
  return (
    <div>
      <div>Conversations</div>
    </div>
  );
}

function ChatThreads(props) {
  const {
    isOpened,
    allConversationsLoading,
    clientId,
    intl,
    emailSignature,
    conversationInfo,
    conversations,
    refetchQuoteEvents
  } = props;
  const conversation =
    conversations.find(
      (el) =>
        el?.eventType === 'CONVERSATION' &&
        !el?.conversation?.parentConversationId
    )?.conversation || {};
  const [isOpen, setIsOpen] = useState(isOpened || false);
  const toggleThread = useCallback(() => {
    setIsOpen(!isOpen);
  });

  return (
    <ThreadWrapper isOpen={isOpen}>
      <ConversationThreadHeader
        conversation={conversation}
        isOpen={isOpen}
        toggleThread={toggleThread}
        getUserName={getUserName}
      />
      <Collapse isOpened={isOpen}>
        <ChatThreadContainer
          currentReplyThread={conversation}
          clientId={clientId}
          intl={intl}
          emailSignature={emailSignature}
          conversationInfo={conversationInfo}
          conversations={conversations}
          allConversationsLoading={allConversationsLoading}
          refetchQuoteEvents={refetchQuoteEvents}
        />
      </Collapse>
    </ThreadWrapper>
  );
}

function ChatThreadContainer(props) {
  const flags = useFlags();
  const {
    currentReplyThread,
    clientId,
    intl,
    parentConversationIdFromParams,
    conversationIdFromParams,
    setSelectedConversation,
    allConversationsLoading,
    emailSignature,
    conversationInfo,
    conversations: updates,
    refetchQuoteEvents
  } = props;
  const appContext = useContext(AppContext);
  const currentUser = appContext?.user || {};
  const isMSP = useUserMSPCheckHook();
  const { company } = appContext;
  const [createClientConversation] = useMutation(CREATE_CLIENT_CONVERSATION, {
    client: AccountClient
  });
  const [showCC, setShowCC] = useState(false);
  const [showBCC, setShowBCC] = useState(false);
  const [replyThreadOpen, setReplyThreadOpen] = useState(false);

  const toggleThreadReply = () => {
    setReplyThreadOpen(!replyThreadOpen);
  };

  const [state, setState] = useState({
    editorState: EditorState.createEmpty(),
    template: {
      name: '',
      content: emailSignature ? `<p><br></p><p><br></p>${emailSignature}` : '',
      placeholdersUsed: '',
      attachments: [],
      inlineImages: []
    },
    toUsers: [],
    content: '',
    parentConversationId:
      currentReplyThread?.parentConversation?.conversationId ||
      currentReplyThread?.conversationId ||
      parentConversationIdFromParams
  });

  const [ccUsers, setCCUsers] = useState(null);
  const [bccUsers, setBCCUsers] = useState(null);
  const [updateReadStatus] = useMutation(UPDATE_READ_STATUS, {
    client: AccountClient
  });
  const isCreateAuthorised = useIsAuthorisedHook('clientConversation.add');
  const quoteConversationRef = useRef();

  // value from user preferred conversation order
  const conversationOrder = getConversationOrder() || 'ASC';

  useEffect(() => {
    if (updates.length > 0) {
      if (conversationOrder === 'ASC') {
        scrollToBottom(quoteConversationRef);
      } else {
        scrollToTop(quoteConversationRef);
      }
    }
  }, [updates]);

  /**
   * Take the cc users from the latest reply
   * It can be either technician or requester's reply
   * If a person in cc replies via email, then we should include that
   * person in cc automatically if that user is not a requester/ a custom email.
   * Also, add to cc if there are cc when a ticket is created from email and if cc is appended there.
   * The type is 'DESCRIPTION' for that case.
   */

  const findLastIndex = (array = [], keyToCompare, keys) => {
    for (let i = array.length - 1; i >= 0; i--) {
      if (array[i]?.user?.accountType === 'MSP') return i;
    }
    return -1;
  };

  const getCCUsersToCarryForward = (convos) => {
    const replyIndex = findLastIndex(convos);
    let allCCUsers = [];
    if (replyIndex > -1) {
      const users = convos[replyIndex]?.ccUsers || [];
      allCCUsers = users.map((el) => {
        return el.user;
      });
      return allCCUsers;
    }
    return [];
  };

  useEffect(() => {
    setState({
      ...state,
      parentConversationId:
        currentReplyThread?.parentConversation?.conversationId ||
        currentReplyThread?.conversationId ||
        parentConversationIdFromParams
    });
    if (currentReplyThread && !currentReplyThread.opened) {
      updateReadStatus({
        variables: {
          conversationId: currentReplyThread?.conversationId,
          status: true
        }
      });
    }
  }, [currentReplyThread]);
  const [showAttachmentPreview, setShowAttachmentPreview] = useState({
    show: false,
    index: 0
  });
  const Tags = {
    sender: Sender,
    receiver: Receiver
  };

  useEffect(() => {
    setState({
      editorState: EditorState.createEmpty(),
      template: {
        name: '',
        content: emailSignature
          ? `<p><br></p><p><br></p>${emailSignature}`
          : '',
        placeholdersUsed: '',
        attachments: [],
        inlineImages: []
      },
      toUsers: [],
      content: '',
      parentConversationId:
        currentReplyThread?.parentConversation?.conversationId ||
        currentReplyThread?.conversationId ||
        parentConversationIdFromParams
    });
    setShowCC(false);
    setShowBCC(false);
    setCCUsers(null);
    setBCCUsers(null);
  }, [clientId]);
  let [formatterAttachment, setFormatterAttachment] = useState([]);
  const {
    loading: recipientsLoading,
    data: recipients,
    error: recipientsError,
    refetch: refetchRecipients
  } = useCachedQuery(GET_CLIENT_CONVERSATION_REPLY_RECIPEINTS, {
    skip: !isMSP || !currentReplyThread?.conversationId,
    client: AccountClient,
    variables: {
      conversationInput: {
        conversationId: currentReplyThread?.conversationId
      }
    },
    onCompleted(res) {
      setBCCUsers(null);
      if (res?.getClientConversationReplyRecipients?.cc) {
        setCCUsers(
          res?.getClientConversationReplyRecipients?.cc.map((el) => {
            return {
              ...el,
              value: el.email,
              label: el.name || el.email
            };
          })
        );
        setShowCC(true);
      } else {
        setCCUsers([]);
        setShowCC(false);
      }
    }
  });

  const updateTemplate = (obj) => {
    const newState = cloneDeep(state);
    newState.template = { ...state.template, ...obj };
    setState(newState);
  };

  const handleFileAttachments = (files) => {
    const formData = new FormData();
    // formData.append('files', files);
    files.forEach((file, idx) => {
      formData.append(`files`, file);
    });
    const details = {
      clientId: clientId
    };
    if (clientId) {
      formData.append('details', JSON.stringify(details));
    }
    formData.append('module', 'CLIENT_CONVERSATION_ATTACHMENT');
    // if (template?.id) {
    //   formData.append('notificationTemplateId', template.id);
    // }
    // for (const property in uploadParams) {
    //   formData.append(property, uploadParams[property]);
    // }

    console.log('FILES are ', files);

    const requestOptions = {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: getHeaderValue()
    };
    fetchApi(`${envConfig.fileRoot}/upload`, requestOptions)
      .then((response) => {
        console.log('email template attachment response is ', response);
        return response.json();
      })
      .then((list) => {
        const newState = cloneDeep(state);
        const updatedTemplate = newState.template;
        const updatedList = [...updatedTemplate?.attachments, ...list.data];
        updatedTemplate.attachments = updatedList;
        setState(newState);
      })
      .catch((err) => {
        console.error('Error:', err);
      });
  };

  const handleAttachmentsDeletion = (fileName) => {
    const newState = cloneDeep(state);
    const updatedTemplate = newState.template;
    const updatedList = cloneDeep(updatedTemplate?.attachments).filter(
      (item) => item.fileName !== fileName
    );
    updatedTemplate.attachments = updatedList;
    setState(newState);
  };

  const composeEmail = (mail, callback) => {
    setLoading(true);
    createClientConversation({
      variables: {
        clientId: props.clientId,
        ...mail
      },
      input: {
        clientId: props.clientId,
        ...mail
      }
    })
      .then((res) => {
        setLoading(false);
        refetchQuoteEvents();
        if (res?.data?.createClientConversation) {
          toast('success', 'Mail composed successfully');
          const newState = cloneDeep(state);
          newState.template = {
            ...state.template,
            name: '',
            content: emailSignature
              ? `<p><br></p><p><br></p>${emailSignature}`
              : '',
            placeholdersUsed: '',
            attachments: [],
            inlineImages: []
          };
          setState(newState);
          refetchRecipients();
          // callback &&
          //   callback(
          //     updatedData?.data?.getClientConversationList?.conversations
          //   );
        } else {
          // toast('error', 'Something went wrong');
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const resetState = (convos) => {
    setState({
      editorState: EditorState.createEmpty(),
      template: {
        name: '',
        content: emailSignature
          ? `<p><br></p><p><br></p>${emailSignature}`
          : '',
        placeholdersUsed: '',
        attachments: [],
        inlineImages: []
      },
      toUsers: [],
      content: '',
      parentConversationId:
        currentReplyThread?.parentConversation?.conversationId ||
        currentReplyThread?.conversationId
    });
    setShowCC(false);
    setShowBCC(false);
    // setCCUsers(getCCUsersToCarryForward(convos));
    setBCCUsers(null);
  };

  const composeMail = () => {
    const rawContent = dompurifier(state?.template?.content) || '';
    setLoading(true);
    const allToUsers =
      recipients?.getClientConversationReplyRecipients?.to || [];
    const allCcUsers = ccUsers?.length
      ? ccUsers.map((el) => {
          return { email: el.email || el.value };
        })
      : null;
    const allBccUsers = bccUsers?.length
      ? bccUsers.map((el) => {
          return { email: el.email };
        })
      : null;
    const toUserMap = getObjectValueCount(allToUsers || [], 'email');
    const ccUserMap = getObjectValueCount(allCcUsers || [], 'email');
    const possibleCCusers = getCCUsers(allCcUsers || [], toUserMap);
    const possibleBccUsers = getBccUsers(
      allBccUsers || [],
      toUserMap,
      ccUserMap
    );
    const attachments =
      state?.template?.attachments.map((att) => ({
        ...pick(att, ['fileName', 'fileSize', 'originalFileName'])
      })) || null;
    composeEmail(
      {
        ...state,
        toUsers: allToUsers
          ? allToUsers.map((el) => {
              return {
                userId: el.userId,
                email: el.email
              };
            })
          : null,
        ccUsers: possibleCCusers,
        bccUsers: possibleBccUsers,
        content: rawContent,
        attachments: attachments
      },
      resetState
    );
  };

  const updateCCState = (sec, val) => {
    switch (sec) {
      case 'cc':
        setShowCC(val);
        break;
      case 'bcc':
        setShowBCC(val);
        break;
      default:
        break;
    }
  };

  const renderConversationBubble = (update) => {
    if (update.eventType === 'CONVERSATION') {
      const conversation = update.conversation || {};
      const userType =
        conversation?.user?.userId === loggedInUser?.userId
          ? 'sender'
          : 'receiver';
      const isConversationViewed = conversation?.viewedByClient;

      return (
        <ConversationBubble
          key={conversation.conversationId}
          conversation={conversation}
          userType={userType}
          loggedInUser={loggedInUser}
          getUserName={getUserName}
          company={company}
          intl={intl}
          clientId={clientId}
          isConversationViewed={isConversationViewed}
          createdTime={update.createdTime}
        >
          <p
            className="message-content"
            dangerouslySetInnerHTML={{
              __html: dompurifier(conversation.content)
            }}
          />
        </ConversationBubble>
      );
    } else if (update.eventType === 'APPROVAL') {
      const conversation = update.approval || {};
      const userType =
        conversation?.user?.userId === loggedInUser?.userId
          ? 'sender'
          : 'receiver';
      const isConversationViewed = conversation?.viewedByClient;

      return (
        <ConversationBubble
          key={conversation.conversationId}
          conversation={conversation}
          userType={userType}
          loggedInUser={loggedInUser}
          getUserName={getUserName}
          company={company}
          intl={intl}
          clientId={clientId}
          isConversationViewed={isConversationViewed}
          createdTime={update.createdTime}
        >
          <TextStyle variation="strong">
            <FormattedMessage
              id={
                conversation.status === 'REJECTED'
                  ? 'quote.details.conversation.rejectedBy'
                  : 'quote.details.conversation.approvedBy'
              }
            />
            &nbsp;
            {getUserName(
              {
                ...conversation,
                user: conversation.approver
              },
              intl
            )}
          </TextStyle>
          {conversation.comment && (
            <div className="p10 rounded-2xl mt10 bg-grey">
              {conversation.comment}
            </div>
          )}
        </ConversationBubble>
      );
    }
  };

  const allToUsers = recipients?.getClientConversationReplyRecipients?.to || [];
  const loggedInUser = appContext.user;
  const [loading, setLoading] = useState(false);

  return (
    <Wrapper className="w100 bg-white">
      <ReplyThreadWrapper className="full-height flex col">
        {allConversationsLoading ? (
          <Loader />
        ) : (
          <>
            <div className="overflow-auto fg1 p10" ref={quoteConversationRef}>
              {updates.map(renderConversationBubble)}
            </div>

            {!replyThreadOpen && (
              <ReplyWidget toggleThreadReply={toggleThreadReply} />
            )}

            {replyThreadOpen && (
              <ComposeSection
                isMSP={isMSP}
                allToUsers={allToUsers}
                updateCCState={updateCCState}
                showCC={showCC}
                showBCC={showBCC}
                ccUsers={ccUsers}
                setCCUsers={setCCUsers}
                bccUsers={bccUsers}
                setBCCUsers={setBCCUsers}
                clientId={clientId}
                intl={intl}
                state={state}
                updateTemplate={updateTemplate}
                handleFileAttachments={handleFileAttachments}
                handleAttachmentsDeletion={handleAttachmentsDeletion}
                toggleThreadReply={toggleThreadReply}
                loading={loading}
                isCreateAuthorised={isCreateAuthorised}
                composeMail={composeMail}
              />
            )}
          </>
        )}
      </ReplyThreadWrapper>
    </Wrapper>
  );
}

export default injectIntl(QuoteConversations);
